import UsedCard from "@resources/js/Components/new/UsedCard.vue";
import {store} from "@resources/js/store";
import LoadingIcon from "../Components/shared/LoadingIcon.vue";

export default class PageYoutubeBlogApp {
  constructor() {
    new Vue({
      el: '#page-youtube-blog-app',
      store: store,
      components: {
        UsedCard, LoadingIcon
      },
      data() {
        return {
          id: window.youtubeId,
          loading: false,
          relatedEquipments: []
        }
      },

      methods: {
        async fetchRelatedItems() {
          try {
            this.loading = true

            const data = await this.$store.dispatch("usedProduct/fetchYoutubeRelatedItems", this.id)
            this.relatedEquipments = data
          } finally {
            this.loading = false
          }
        }
      },

      mounted() {
        this.fetchRelatedItems();
      }
    })
  }
}

$(document).on("ready", () => {
  window.PageYoutubeBlogApp = new PageYoutubeBlogApp()
});



// WEBPACK FOOTER //
// ./resources/js/pages/PageYoutubeBlogApp.js